import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { AppConfigService } from 'app/app-config';

export const isNotProdGuard: CanMatchFn = () => {
  const appConfigService = inject(AppConfigService);

  return appConfigService.appContext?.notProd ?? false;
};
